/**
 * Cookies JavaScript singleton module
 */

var Cookies = (function($) {

  function initCookies() {
    // do something

    setTimeout(function(){ $.cookie('loaded', 'yes', { path: '/' }); }, 300);
    

    if (typeof $.cookie('loaded') === 'undefined'){
        $('#loader').hide();
    } else {
        
    }
    
  }

  function init() {


    initCookies();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Cookies.init);
